import { IconProps } from './types';

import CommentSvg from 'images/srp-comment.svg';

const Events = ({ className }: IconProps) => {
  return <img className={className} src={CommentSvg} />;
};

export default Events;
